module.exports = __webpack_public_path__ + "static/media/Group 56.69f31205.png";